<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-update-data="methods.updateData"
        :method-create-data="methods.createData"
        :method-update-scheme="methods.updateScheme"
        :additional-validation-rules="rules"
        :send-all-form="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import addCollectionsToScheme from "@/utils/addCollectionsToScheme";
import {
  getUsersId as fetchData,
  postUsers as createData,
  putUsersId as updateData,
} from "@/api/users";
import { Users as defaultScheme } from "@/api/schemes/users";

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

const rules = {
  confirm_password: function () {
    return {
      validator: async (rule, value, callback) => {
        if (!this.form) {
          callback();
          return;
        }
        if (!value) {
          callback();
        } else if (this.form.password !== value) {
          // проверка на наличие региональных инструкций
          callback(new Error("Пароли не совпадают"));
        } else {
          callback();
        }
      },
      trigger: "change",
    };
  },
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      rules,
      scheme: defaultScheme,
      methods: {
        fetchData,
        createData,
        updateData,
        updateScheme,
      },
    };
  },
};
</script>
